"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.search = void 0;
var tslib_1 = require("tslib");
var api_1 = tslib_1.__importStar(require("./api"));
var query_string_1 = tslib_1.__importDefault(require("query-string"));
function search(q) {
    var queryParams = query_string_1.default.stringify({ q: q });
    return api_1.default
        .get("".concat(process.env.REACT_APP_SEARCH_SERVICE_URL, "/menu?").concat(queryParams))
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.search = search;
var api = {
    search: search,
};
exports.default = api;
